import { getStore } from '~/mobx/AppStore';

const handlePreviewBallot = () => {
    const { generalSettingsStore, regionPreviewStore, regionStore, companyStore } = getStore();

    const sid = regionPreviewStore.sid;
    const selectedCompany = companyStore.selectedCompany;
    const slagId = selectedCompany?.number;
    const electionId = generalSettingsStore.selectedElectionId;
    const regionId = regionStore.selectedRegion?.id;

    const url = new URL(regionPreviewStore.ballotPreviewRedirectUrl);
    if (sid) url.searchParams.set('sid', sid);
    if (slagId) url.searchParams.set('slagid', slagId);
    if (electionId) url.searchParams.set('electionid', electionId);
    if (regionId) url.searchParams.set('regionid', regionId);

    window.open(url.toString());
};

export default handlePreviewBallot;
